import React from 'react';
import styled from 'styled-components';

const StyledHomeIcon = styled.svg`
  width: 30px;
  height: 30px;
  filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.3));
  transition: fill 0.2s ease;
`;

const HomeIcon: React.FC = () => (
  <StyledHomeIcon viewBox="0 0 24 24">
    <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
  </StyledHomeIcon>
);

export default HomeIcon;